module.exports = __webpack_public_path__ + "assets/img/duibuqi.1f55c535.png";